import { create } from "zustand";
import { persist } from "zustand/middleware";

interface CookieConsentState {
  accepted: boolean;
  setAccepted: (accepted: boolean) => void;
}

export const useCookieConsentStore = create<CookieConsentState>()(
  persist(
    set => ({
      accepted: false,
      setAccepted: (accepted: boolean): void => {
        set({ accepted });
      }
    }),
    {
      name: "cookie-consent"
    }
  )
);
